/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Query } from 'fierry/flux'

import Time from 'shared/client/time';


export default new Query([ Time ], (time) =>
{
  return time.getClientDate();
});
